export class ReservationModel{
  patientCode ='';
  patientName = '';
  resDate :any;
  resDate1 = '2022-01-01';

  resTime = '2022-01-01';
  resToTime = '2022-01-01';

  resTime1 = '2022-01-01';
  resToTime1 = '2022-01-01';

  resDuration = '';
  resRoom = '';
  resRoomDesc = '';
  resDoc = '';
  resDocName = '';
  resType = '';
  resNotes = '';
  resStatus = '';
  resPhone ='';
  id = 0;
  userID = '';
  resconsultant = '';
  resonline = '';
  modifiedDate = '2021-01-01';
  compCode = '1';
}
